// Backend API Configuration

//export const baseUrl = "https://willovate-servises.onrender.com";
//export const API_BASE_URL = "https://willovate-servises.onrender.com/api";

export const baseUrl = process.env.REACT_APP_API_URL ||  "http://localhost:5201";
export const API_BASE_URL = `${baseUrl}/api`;



// For localhost only: "http://localhost:3000"
export const frontEndbaseUrl = "https://resto.willovate.in";

// Auth headers utility
export const getAuthHeaders = (token?: string) => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};
